import { render, staticRenderFns } from "./FirstBox.vue?vue&type=template&id=256559e6&scoped=true&"
import script from "./FirstBox.vue?vue&type=script&lang=js&"
export * from "./FirstBox.vue?vue&type=script&lang=js&"
import style0 from "./FirstBox.vue?vue&type=style&index=0&id=256559e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256559e6",
  null
  
)

export default component.exports